module.exports = __webpack_public_path__ + "img/stereoscopic_cam2.e02b9338.jpg";